<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="/img/is/nusanet.png" height="42" alt="Nusanet">
      </b-link>
      <SidebarToggler class="d-md-down-none sideleft" display="lg" />
      <div style="font-size: 16px; height:60px" id="breadcrumb">
        <Breadcrumb :list="list" style="border-bottom: none"/>
      </div>
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="d-md-down-none">
          <i class="icon-bell"></i>
          <b-badge pill variant="danger">5</b-badge>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <div>
                <b-form-input type="text" placeholder="Search"></b-form-input>
          </div>
        </b-nav-item>
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader>
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Search" v-bind:model="inputSearch" @input="updateText"  >
            <div class="input-group-prepend">
              <button class="collap" @click="collapseall"> <i class="fa fa-indent"></i> </button>
              <button class="collap" @click="uncollapseall"><i class="fa fa-outdent"></i> </button>
            </div>
          </div>
        </SidebarHeader>
        <SidebarNavIS :navItems="navigation"></SidebarNavIS>
      </AppSidebar>
      <main class="main">
        <div class="container-fluid">
          <div class="overlay" v-if="$store.getters.loading">
            <div class="loading">
              <bounce-loader ></bounce-loader>
              Loading
            </div>
            <div class="backg-lg"></div>
          </div>
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="https://mdn.nusa.net.id">Nusanet</a>
        <span class="ml-1">&copy; 2019 creativeLabs.</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="https://mdn.nusa.net.id">Nusanet@AnC</a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import {getService} from '../services'
import SidebarNavIS from '../component/navigasi_is/SidebarNavIS'
import BounceLoader from 'vue-spinner/src/BounceLoader'
export default {
  name: 'DefaultContainer',
  components: {
    BounceLoader,
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    SidebarNavIS
  },
  data () {
    return {
      nav: nav.items,
      navigation: nav.items,
      inputSearch: '',
      time:'',
      loading: true
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  created: function(){
    // console.log(this.navigation)
    // getService.navigation()
    //   .then(
    //     nav => {
    //       this.navigation = this.changeData(nav);
    //       this.nav = this.navigation
    //     }
    //   ),
    //   setTimeout(() => {
    //     // this.loading = false
    //   }, 3000)
  },
  methods: {
    changeData: function(nav) {
      let i, j, nav_menu, k, child, child2, nav_menu1, nav_menu2;
      nav_menu = [];
      nav_menu2 = [];
      nav_menu1 = [];
      if (nav) {
       for ( i = 0; i < nav.length ; i++) {
         if (nav[i].children) {
           child = nav[i].children;
           nav_menu1 = [];
           for (k in child) {
             if (child.hasOwnProperty(k)) {
               nav_menu2 = [];
               if (child[k].children) {
                 child2 = child[k].children;
                 for (j = 0; j < child2.length; j++ ) {
                   const c2 = {
                     'name': child2[j].name,
                     'url': child2[j].url
                   };
                   nav_menu2.push(c2);
                 }
               }
               if (nav_menu2.length > 0) {
                 const c1 = {
                   'name': child[k].name,
                   'url': child[k].url,
                   'children': nav_menu2
                 }
                 nav_menu1.push(c1);
               } else {
                 const c1 = {
                   'name': child[k].name,
                   'url': child[k].url
                 }
                 nav_menu1.push(c1);
               }
             }
           }
           if (nav_menu1.length > 0) {
             const c0 = {
               'name': nav[i].name,
               'url': nav[i].url,
               'children': nav_menu1
             }
             nav_menu.push(c0);
           } else {
             const c0 = {
               'name': nav[i].name,
               'url': nav[i].url
             }
             nav_menu.push(c0);
           }
         }
       }
      return nav_menu;
      }
    },
    updateText(e) {
      const text = e.target.value;
      if (text == '' ) {
        clearTimeout(this.time);
        this.navigation = this.nav
        this.changeClass('searchlink', 'firstNav')
      } else {
        clearTimeout(this.time);
        this.time = setTimeout( () => {
          this.navigation = this.filterBy(this.nav, text)
          setTimeout( () => {
            this.collapseall()
          }, 100)
          // console.log(this.filterBy(this.navigation, text))
          this.changeClass('searchlink', 'firstNav')
        }, 500);
      }
    },
    filterBy(navigation, text) {
      var result, textmatch, result1, result2;
      result = [];
      var children1, children2;
      var mode_parent;
      for (var i = 0, len = navigation.length; i < len; i++) {
        children1 = false;
        result1 =[];
        var navigation1 = navigation[i];
        if (navigation1. children) {
          textmatch = this.matchText(navigation1.name, text)
          if (textmatch) {
            result.push(navigation1)
          } else {
            for ( var j = 0, len1 = navigation1.children.length; j < len1; j++) {
              var nav = navigation1.children[j]
              children2 = false
              result2 = []
              if (nav.children) {
                textmatch = this.matchText(nav.name, text)
                if (textmatch) {
                  children1 = true;
                  result1.push(nav)
                } else {
                  for (var k = 0, len2 = nav.children.length; k < len2; k++) {
                    var navigation2 = nav.children[k]
                    textmatch = this.matchText(navigation2.name, text)
                    if (textmatch) {
                      children2 = true
                      result2.push(this.createData(navigation2.url, navigation2.name))
                    }
                  }
                }
                if(children2) {
                  const res2 = {
                    'url': nav.url,
                    'name': nav.name,
                    'children': result2
                  }
                  children1 = true;
                  result1.push(res2)
                }
              } else {
                textmatch = this.matchText(nav.name, text)
                if (textmatch) {
                  children1 = true;
                  result1.push(this.createData(nav.url, nav.name))
                }
              }

            }
          }
          if(children1) {
            const res = {
              'url': navigation[i].url,
              'name': navigation[i].name,
              'children': result1
            }
            result.push(res)
          }
        } else {
          textmatch = this.matchText(navigation1.name, text)
          if (textmatch) {
            result.push(this.createData(navigation[i].url, navigation[i].name))
          }
        }
      }
      return result;
    },
    matchText(text1, text2) {
      text1 = text1.toUpperCase()
      text2 = text2.toUpperCase()
      var m = text1.match(text2);
      if (m == null) {
        return false
      } else {
        return true
      }
    },
    createData(url, name) {
      const data = {
        'url': url,
        'name': name
      }
      return data
    },
    collapseall() {
      const nav = document.getElementById("navigations")
      var panel = nav.querySelectorAll('.nav-dropdown')
      for (var i = 0 , len = panel.length; i < len; i++) {
        panel[i].classList.add('open')
      }
      // const element =
    },
    uncollapseall() {
      const nav = document.getElementById("navigations")
      var panel = nav.querySelectorAll('.nav-dropdown')
      for (var i = 0, len = panel.length; i < len; i++) {
        panel[i].classList.remove('open')
      }
    },
    changeClass(from, target) {
      const clas = '.' + from;
      var container = document.getElementById("navigations");
      var panel = container.querySelectorAll(clas);
      for (var i = 0, len = panel.length; i < len; i++) {
        panel[i].classList.remove(from);
        panel[i].classList.add(target);
      }
    }
  }
}
</script>

<style scoped>
  .loading{
    text-align: -webkit-center;
    text-align: -moz-center;
    font-size: 32px;
    top: 30%;
    color: #2a2d2d;
    position: absolute;
    width: 100%;
    z-index: 8000;
  }

  .backg-lg {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #7f7f7f47;
    margin-left: 30px;
  }

  .overlay{
    height: 100%;
    z-index: 7000;
    width: 100%;
    position: fixed;
    margin-left: -30px;

  }

  .container-fluid {
    padding: 0px !important;
  }
</style>
